import { createContext } from 'react';

import type { Text } from 'src/__generated__/graphqlTypes';

import { BlockPosition } from '../config/constants';

export const ExtraComponents = createContext<null | Record<BlockPosition, Array<Text>>>(null);
